import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { DELIVERY_ERROR_MESSAGE, ServiceCodes } from '@checkout-v2/const';
import { DeliveryAddressService, ServicesService } from '@checkout-v2/feature';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SdvorIconComponent, SdvorRadioComponent, SystemMessageComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';
import { filter } from 'rxjs';
import { CheckoutValidationErrorComponent } from '../../checkout-validation-error';
import { LiftingOptionsComponent } from './lifting-options';

@Component({
  selector: 'sd-services',
  imports: [
    ReactiveFormsModule,
    SdvorIconComponent,
    NgbTooltipModule,
    LiftingOptionsComponent,
    SdvorRadioComponent,
    CheckoutValidationErrorComponent,
    SystemMessageComponent,
  ],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicesComponent implements OnInit {
  private readonly deliveryAddressService = inject(DeliveryAddressService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly servicesService = inject(ServicesService);

  protected readonly iconTypes = IconTypes;
  protected readonly errorMessage = DELIVERY_ERROR_MESSAGE;

  protected readonly serviceItems = toSignal(this.servicesService.getServices());
  protected readonly isLoading = toSignal(this.servicesService.getServicesLoading());
  protected readonly isError = toSignal(this.servicesService.getServicesError());
  protected readonly isSuccess = toSignal(this.servicesService.getServicesSuccess());

  protected readonly activeOptionCode = toSignal(this.servicesService.getServicesActiveOptionCode());
  protected readonly activeOption = toSignal(this.servicesService.getServicesActiveOption());
  protected readonly deliveryAddress = toSignal(this.deliveryAddressService.activeAddress$);

  protected readonly radioControl = new FormControl<ServiceCodes | undefined>(undefined, Validators.required);

  constructor() {
    /** Синхронизация значения формы при изменении стора */
    effect(() => {
      const activeOptionCode = this.activeOptionCode();

      if (this.radioControl.value !== activeOptionCode) {
        this.radioControl.setValue(activeOptionCode, { emitEvent: false });
      }
    });
  }

  ngOnInit(): void {
    /** Отправка значения в стор при изменении значения формы */
    this.radioControl.valueChanges.pipe(filter(Boolean), takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.servicesService.setServicesActiveOption(value);
    });
  }
}
